<template>
  <div class="editRoaming">
    <div class="editRoaming-title">
      <i
        class="el-icon-back"
        @click="rebackRoaming"></i
      >漫游视口列表
    </div>
    <div class="editRoaming-opera">
      <el-button
        :disabled="!isPlay"
        @click="addViewPort"
        size="small"
        plain
        class="normal-btn primary-ang-btn"
        >添加视口</el-button
      >
      <el-button
        @click="isPlay ? playRoam() : pauseRoam()"
        :disabled="!roamingInfo.viewPorts?.length"
        size="small"
        plain
        class="normal-btn primary-ang-btn"
        >{{ isPlay ? '播放' : '暂停' }}</el-button
      >
      <el-button
        @click="stopRoam"
        :disabled="!roamingInfo.viewPorts?.length"
        size="small"
        plain
        class="normal-btn primary-ang-btn"
        >停止</el-button
      >
      <el-button
        @click="deleteAllRoamViewport"
        :disabled="!isPlay || roamingInfo.viewPorts?.length === 0"
        size="small"
        plain
        class="normal-btn primary-ang-btn"
        >删除全部</el-button
      >
    </div>
    <div class="editRoaming-info">
      <div class="editRoaming-info-item">
        <div class="editRoaming-info-item-label dialog-label">路径名称:</div>
        <div class="editRoaming-info-item-value">
          <el-input
            :disabled="!isPlay"
            class="input-primary"
            :maxlength="30"
            @change="changeRoamName"
            show-word-limit
            v-model="roamingInfo.name"
            placeholder="请输入"></el-input>
        </div>
      </div>
      <div class="editRoaming-info-item">
        <div class="editRoaming-info-item-label dialog-label">漫游速度:</div>
        <div class="editRoaming-info-item-value">
          <el-input
            :disabled="!isPlay"
            type="number"
            @input="disabledInput()"
            class="input-primary"
            @change="changeRoamName"
            v-model="roamingInfo.speed"
            placeholder="请输入"></el-input>
          <span class="unit">
            <el-select
              :disabled="!isPlay"
              class="primary-select"
              v-model="roamingInfo.speedUnit"
              placeholder="请选择"
              @change="changeRoamName"
              :popper-append-to-body="false">
              <el-option
                v-for="(item, index) in speedUnitList"
                :title="item.label"
                :key="index"
                :label="item.label"
                :value="item.value" />
            </el-select>
          </span>
        </div>
      </div>
    </div>
    <div class="editRoaming-cardList">
      <div class="editRoaming-cardList-title">
        <span class="editRoaming-cardList-title-text">视口列表</span>
      </div>
      <div
        class="editRoaming-cardList-listContent"
        v-if="roamingInfo.viewPorts?.length">
        <div
          class="editRoaming-cardList-list"
          v-for="(item, index) in roamingInfo.viewPorts"
          :class="
            defaultStartIndex === index ? `activeView ${index}` : `${index}`
          "
          :key="index">
          <div class="editRoaming-cardList-list-content">
            <img
              @mouseover="handleImgItemMouseOver(item?.thumbnail)"
              @mouseleave="handleImgItemMouseLeave"
              class="editRoaming-cardList-list-content-img"
              :src="item?.thumbnail" />
            <div class="editRoaming-cardList-list-content-rightWrapper">
              <div class="editRoaming-cardList-list-content-rightWrapper-title">
                <el-input
                  @blur="() => (item.editName = !item.editName)"
                  v-show="item.editName"
                  :maxlength="30"
                  show-word-limit
                  @change="changeViewPortName(item)"
                  class="input-primary editViewPortName"
                  v-model="item.name"></el-input>
                <span
                  v-show="!item.editName"
                  :title="item?.name"
                  class="editRoaming-cardList-list-content-rightWrapper-title-text"
                  >{{ item?.name ?? '-' }}</span
                >
                <i
                  class="el-icon-edit edit"
                  v-show="isPlay"
                  @click="editViewName(item)"></i>
              </div>
              <div class="editRoaming-cardList-list-content-btnlist">
                <el-dropdown
                  placement="bottom-start"
                  @command="current => roamingInsert(current, item)"
                  trigger="click"
                  :append-to-body="false">
                  <div title="插入视口">
                    <el-button
                      :disabled="!isPlay"
                      size="small"
                      plain
                      class="normal-btn primary-ang-btn"
                      >插入视口<i class="el-icon-arrow-down"></i>
                    </el-button>
                  </div>
                  <el-dropdown-menu
                    slot="dropdown"
                    class="common-roaming-dropdown-box dropdown-primary">
                    <el-dropdown-item command="1">
                      <span>向上插入</span>
                    </el-dropdown-item>
                    <el-dropdown-item command="2">
                      <span>向下插入</span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-button
                  :disabled="!isPlay"
                  @click="roamingPosition(item)"
                  size="small"
                  plain
                  class="normal-btn primary-ang-btn"
                  >定位
                </el-button>
                <el-button
                  :disabled="!isPlay"
                  @click="roamingRefresh(item)"
                  size="small"
                  plain
                  class="normal-btn primary-ang-btn"
                  >更新</el-button
                ><el-button
                  :disabled="!isPlay"
                  @click="viewPortDel(item)"
                  size="small"
                  plain
                  class="normal-btn primary-ang-btn"
                  >删除</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="emptyData"
        v-else>
        <bj-empty
          :image="require('@/assets/img/no-data.png')"
          class="empty-page">
          <template slot="description">
            <span class="empty-text">抱歉，暂无漫游视口数据</span>
          </template>
        </bj-empty>
      </div>
    </div>
    <div
      class="viewport-img-box"
      v-show="isViewportImgVisible">
      <img
        :src="viewportImg"
        alt=""
        srcset="" />
    </div>
  </div>
</template>

<script>
import { createViewportImg } from '@/utils'
import { getCameraViewAngle } from '@/utils/engineUtils'
import {
  addRoam,
  editRoam,
  editRoamViewportName,
  editRoamNameAndSpeed,
  editRoamViewportAngle,
  getRoamDetails,
  deleteRoamViewport,
  deleteRoamViewportAll
} from '@/service/roam/index.js'
import { omit } from 'lodash-es'
import { roamingPlay, roamingStop, roamingPause } from './'
export default {
  data() {
    return {
      roamingInfo: {
        name: '',
        speed: 200,
        speedUnit: 'Meter',
        viewPorts: []
      },
      speedUnitList: [
        {
          label: 'm/s',
          value: 'Meter'
        },
        {
          label: 'km/s',
          value: 'Kilometer'
        }
      ],
      saveRoamId: '',
      viewPortId: '',
      isPlay: true,
      pauseInfoList: [],
      defaultStartIndex: '',
      viewportImg: '',
      isViewportImgVisible: false
    }
  },
  methods: {
    // 校验输入值
    // validText(text) {
    //   const reg = /^[0-9]+(.[0-9]{1,2})?$/
    //   if (!reg.test(this.roamingInfo.speed)) {
    //     this.roamingInfo.speed = ''
    //     this.$message.error('请输入数字，最多保留两位小数')
    //   }
    //   if (!text) {

    //   }
    // },

    handleImgItemMouseOver(viewportInfo) {
      this.viewportImg = viewportInfo
      this.isViewportImgVisible = true
    },
    handleImgItemMouseLeave() {
      this.isViewportImgVisible = !this.isViewportImgVisible
    },

    disabledInput() {
      if (this.roamingInfo.speed.toString().length > 15) {
        this.$nextTick(() => {
          this.roamingInfo.speed = this.roamingInfo.speed
            .toString()
            .slice(0, 15)
        })
      }

      // 自动去除前导零（可选）
      if (
        this.roamingInfo.speed.toString() > 1 &&
        this.roamingInfo.speed.toString().startsWith('0')
      ) {
        this.$nextTick(() => {
          this.roamingInfo.speed =
            this.roamingInfo.speed.toString().replace(/^0+/, '') || '0'
        })
      }
    },

    // 修改路径名称
    async changeRoamName(text) {
      const roamInfo = omit(this.roamingInfo, ['viewPorts'])
      roamInfo.sceneRoamId = this.saveRoamId
      if (roamInfo?.name === '') {
        return this.$message.error('请输入路径名称')
      }
      if (roamInfo?.speed === '') {
        return this.$message.error('请输入漫游速度')
      }
      const { isSuccess, errMsg } = await editRoamNameAndSpeed(roamInfo)
      if (!isSuccess) {
        this.$message.error(errMsg)
      }
    },

    // 新增漫游视口
    async roamingSaveAll(params) {
      this.roamingInfo = { ...this.roamingInfo, ...params }
      // this.roamingInfo.name = name
      // this.roamingInfo.speed = Number(this.roamingInfo.speed)
      this.roamingInfo.sceneId = this.getSceneId
      const data = await addRoam(this.roamingInfo)
      if (data?.isSuccess) {
        this.$emit('saveRoaming', this.roamingInfo)
        this.saveRoamId = data.data
      } else {
        this.$message.error(data?.errMsg ?? '保存失败')
      }
    },
    // 漫游数据修改----------------------------

    // 获取列表最大索引
    findMaxIndex(arr = []) {
      // 容错处理：空数组直接返回初始序号
      if (!arr.length) return 1
      // 使用正则提取数字，避免 split 误分割
      const pattern = /视口(\d+)/
      let max = -Infinity

      // 单次遍历同时完成有效值过滤和最大值计算
      for (const { name } of arr) {
        const match = name?.match(pattern)
        const num = match ? parseInt(match[1], 10) : NaN
        if (!isNaN(num) && num > max) {
          max = num
        }
      }
      return max !== -Infinity ? max + 1 : 1
    },

    // 视口数据重新编排
    async arrangeViewPort(isInsert = false, direction = 'up', viewPortId) {
      const data = await createViewportImg()
      const getCameraViewPort = getCameraViewAngle()
      const sort = this.findMaxIndex(this.roamingInfo.viewPorts)
      const currentViewPort = {
        name: '视口' + sort,
        base64Image: data.replace(/^data:image\/\w+;base64,/, ''),
        visualAngle: getCameraViewPort
      }
      const editRoamViewportName = this.roamingInfo.viewPorts.map(item => {
        return omit(item, [
          'base64Image',
          'editName',
          'thumbnail',
          'visualAngle'
        ])
      })
      if (isInsert) {
        const insertData = {
          ...this.roamingInfo,
          viewPorts: editRoamViewportName
        }
        const index = this.roamingInfo.viewPorts.findIndex(
          i => i.viewPortId === viewPortId
        )
        if (direction === 'up') {
          insertData.viewPorts.splice(index, 0, currentViewPort)
        } else {
          insertData.viewPorts.splice(index + 1, 0, currentViewPort)
        }
        return insertData
      } else {
        editRoamViewportName.push(currentViewPort)
        const roamInfoList = {
          ...this.roamingInfo,
          viewPorts: editRoamViewportName
        }
        return roamInfoList
      }
    },

    // 视口插入
    async roamingInsert(key, item) {
      let roamInfoList
      if (key === '1') {
        roamInfoList = await this.arrangeViewPort(true, 'up', item.viewPortId)
      } else if (key === '2') {
        roamInfoList = await this.arrangeViewPort(true, 'down', item.viewPortId)
      }
      const { isSuccess, errMsg } = await editRoam(roamInfoList)
      if (isSuccess) {
        this.getRoamDetails()
      } else {
        this.$message.error(errMsg)
      }
    },
    editViewName(item) {
      item.editName = !item.editName
    },
    // 添加视口
    async addViewPort() {
      this.roamingInfo = omit(this.roamingInfo, ['sceneId'])
      this.roamingInfo.sceneRoamId = this.saveRoamId
      const roamInfoList = await this.arrangeViewPort()
      const { isSuccess, errMsg } = await editRoam(roamInfoList)
      if (isSuccess) {
        this.getRoamDetails()
      } else {
        this.$message.error(errMsg)
      }
    },

    // 获取漫游详情
    async getRoamDetails(id = this.saveRoamId) {
      const detailInfo = await getRoamDetails(id)
      if (!detailInfo?.isSuccess) {
        return this.$message.error(detailInfo.errMsg)
      }
      this.roamingInfo = detailInfo.data
      this.roamingInfo.viewPorts = detailInfo.data?.viewPorts.map(item => {
        return {
          ...item,
          thumbnail: `${window.imageBaseUrl}/` + item?.thumbnail,
          editName: false
        }
      })
      return detailInfo
    },

    // 编辑漫游信息
    async editRoamInfo(id) {
      this.saveRoamId = id
      const { isSuccess, errMsg, data } = await this.getRoamDetails(id)
      if (!isSuccess) {
        return this.$message.error(errMsg)
      }
      return data
    },

    // 修改视口名称
    async changeViewPortName(item) {
      if (!item?.name) {
        return this.$message.error('请输入视口名称')
      }
      const { isSuccess, errMsg } = await editRoamViewportName({
        name: item.name,
        viewPortId: item.viewPortId
      })
      if (!isSuccess) {
        this.$message.error(errMsg)
      } else {
        this.getRoamDetails(this.saveRoamId)
      }
    },

    // 获取漫游数据
    async getRoamListViewPort() {
      const infoList = this.roamingInfo.viewPorts.map(item => item.visualAngle)
      const roamSpeedUnit = this.roamingInfo.speedUnit === 'Meter' ? 1 : 1000
      const totalRoamSpeed = Number(this.roamingInfo.speed) * roamSpeedUnit
      return {
        ...this.roamingInfo,
        totalRoamSpeed,
        viewPorts: infoList
      }
    },

    //开始播放
    async playRoam() {
      this.defaultStartIndex = 0
      let playRoam
      const roamingInfo = await this.getRoamListViewPort()
      if (!this.pauseInfoList?.length) {
        playRoam = roamingInfo.viewPorts
      } else {
        playRoam = this.pauseInfoList
      }
      this.isPlay = false
      roamingPlay(
        playRoam,
        roamingInfo.totalRoamSpeed,
        this.isPlay,
        this.playRoamEnd,
        this.playRoamEndFrame
      )
    },

    // 暂停播放
    async pauseRoam() {
      const currentIndex = roamingPause()
      const roamingInfo = await this.getRoamListViewPort()
      let playRoamList
      if (!this.pauseInfoList?.length) {
        playRoamList = roamingInfo.viewPorts
      } else {
        playRoamList = this.pauseInfoList
      }
      const currentViewPort = getCameraViewAngle()
      this.isPlay = true
      window.BlackHole3D.Camera.setCamLocateTo(
        JSON.parse(currentViewPort),
        0,
        1
      )
      const cameraPositionList = playRoamList.slice(currentIndex)
      const cameraPositionListInfo = [currentViewPort, ...cameraPositionList]
      this.pauseInfoList = cameraPositionListInfo
    },

    // 漫游播放结束
    playRoamEnd(_, index) {
      this.isPlay = true
      this.pauseInfoList = []
      this.defaultStartIndex = ''
    },

    // 漫游每一帧结束
    async playRoamEndFrame(item) {
      const index = this.roamingInfo.viewPorts.findIndex(
        list => list.visualAngle === JSON.stringify(item)
      )
      this.defaultStartIndex = index
    },

    // 停止漫游
    async stopRoam() {
      this.pauseInfoList = []
      this.isPlay = true
      this.defaultStartIndex = ''
      const roamingInfo = await this.getRoamListViewPort()
      roamingStop(roamingInfo.viewPorts)
    },

    clearRoamList() {
      this.roamingInfo = {
        name: '',
        speed: 1,
        speedUnit: 'Meter',
        viewPorts: []
      }
    },

    deleteAllRoamViewport() {
      this.$confirm('此操作将删除所有视口, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const { isSuccess, errMsg } = await deleteRoamViewportAll(
            this.saveRoamId
          )
          if (isSuccess) {
            this.getRoamDetails(this.saveRoamId)
          } else {
            this.$message.error(errMsg)
          }
        })
        .catch(() => {})
    },
    // 视口定位
    roamingPosition(item) {
      const camera = item.visualAngle
      window.BlackHole3D.Camera.setCamLocateTo(JSON.parse(camera), 0, 1)
    },
    async roamingRefresh(item) {
      const viewImg = await createViewportImg()
      const positionInfo = {
        viewPortId: item.viewPortId,
        base64Image: viewImg.replace(/^data:image\/\w+;base64,/, ''),
        visualAngle: getCameraViewAngle() || ''
      }
      const { isSuccess, errMsg } = await editRoamViewportAngle(positionInfo)
      if (!isSuccess) {
        this.$message.error(errMsg)
      } else {
        this.getRoamDetails(this.saveRoamId)
      }
    },
    async viewPortDel(item) {
      this.$confirm('此操作将永久删除该视口，确认继续吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const data = await deleteRoamViewport(item.viewPortId)
        if (data?.isSuccess) {
          const details = await this.getRoamDetails()
        } else {
          this.$message.error(data?.errMsg ?? '删除失败')
        }
      })
    },
    async rebackRoaming() {
      this.stopRoam()
      this.roamingInfo = {
        name: '',
        speed: 1,
        speedUnit: 'Meter',
        viewPorts: []
      }
      this.saveRoamId = ''
      this.viewPortId = ''
      this.$emit('rebackRoaming')
    }
  },
  computed: {
    getSceneId() {
      return this.$route.query.sceneId
    }
  }
}
</script>

<style scoped lang="less">
@import '@/assets/css/publishSearch.less';
.editRoaming {
  height: 100%;
  position: relative;
  &-title {
    height: 28px;
    background: var(--roaming-title-bgColor);
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    color: var(--empty-edit-title-text-color);
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .el-icon-back {
      cursor: pointer;
      padding: 0 8px;
      font-size: 16px;
      font-weight: 600;
      color: var(--base-primary-bgColor);
    }
  }

  &-opera {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 6px 0;

    :deep(.el-button) {
      padding: 6px;
      font-size: 12px;
      min-width: 54px;
      padding: 7px 9px;
      &:not(:last-child) {
        margin-left: 8px;
      }

      &:first-child {
        margin-left: 0;
      }
    }
  }
  &-info {
    margin-bottom: 6px;

    &-item {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      &:not(:last-child) {
        margin-bottom: 8px;
      }

      &-label {
        margin-right: 6px;
      }
      &-value {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex: 1;
        :deep(.el-input__inner) {
          height: 32px;
          line-height: 16px;
          &[type='number'] {
            &::-webkit-outer-spin-button,
            &::-webkit-inner-spin-button {
              -webkit-appearance: none;
              margin: 0;
            }
            -moz-appearance: textfield;
          }
        }

        .unit {
          margin-left: 8px;
          .primary-select {
            :deep(.el-input__inner) {
              height: 32px !important;
            }
            :deep(.el-input__icon) {
              line-height: 26px;
            }
            :deep(.el-select-dropdown__list) {
              padding-bottom: 0;
            }
          }
        }
      }
    }
  }
  &-cardList {
    height: calc(100% - 136px);
    overflow-y: auto;
    &-title {
      height: 26px;
      background: var(--base-bg-dark-color33);
      border-radius: 4px;
      line-height: 26px;
      text-align: left;
      padding-left: 8px;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-bottom: 8px;
      &-text {
        color: var(--roaming-edit-list-title-color);
        font-size: 14px;
        font-weight: 400;
        white-space: nowrap;
      }
    }
    .activeView {
      border: 1px solid var(--base-primary-bgColor);
    }
    &-listContent {
      height: calc(100% - 34px);
      overflow-y: auto;
    }
    &-list {
      border-radius: 8px;
      padding: 8px;
      background: var(--base-bg-dark-color33);
      border: 1px solid var(--roaming-list-border-color);
      &:not(:last-child) {
        margin-bottom: 8px;
      }

      &-title {
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }

      &-content {
        display: flex;
        justify-content: flex-start;
        &-img {
          width: 96px;
          height: 54px;
          border-radius: 6px;
          margin-right: 12px;
          object-fit: cover;
        }
        &-rightWrapper {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: flex-start;
          width: calc(100% - 124px);
          &-title {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            width: 100%;
            .editViewPortName {
              :deep(.el-input__inner) {
                height: 26px;
                line-height: 26px;
                width: 100%;
              }
            }
            &-text {
              max-width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              font-size: 14px;
              font-weight: 400;
              color: var(--roaming-edit-list-title-color);
              white-space: nowrap;
            }

            .edit {
              margin-left: 6px;
              font-size: 12px;
              font-weight: 600;
              margin-top: 2px;
            }
          }
        }
        &-btnlist {
          display: flex;
          justify-content: flex-start;
          align-items: center;

          :deep(.el-dropdown) {
            margin-right: 8px;
          }

          :deep(.el-button) {
            font-size: 12px;
            padding: 3px 4px;
          }

          .el-icon-arrow-down {
            margin-left: 4px;
          }
        }
      }
    }
  }
  .viewport-img-box {
    transition: all 0.3s;
    position: absolute;
    left: -425px;
    top: 50%;
    transform: translateY(-50%);
    width: 400px;
    height: 225px;
    background-size: cover;
    background-position: center;
    z-index: 3;
    box-shadow: var(--base-bg-dark-color30);
    border-radius: 8px;
    border: 4px solid var(--base-border-dark-color21);
    img {
      width: 100%;
      height: 100%;
      border-radius: 4px;
      object-fit: cover;
    }
  }
}
</style>

<style lang="less">
.common-roaming-dropdown-box {
  width: auto !important;

  :deep(.el-dropdown-menu__item) {
    padding-right: 8px;
  }
}
</style>
